export default "__VITE_ASSET__rBNB3gKv__"